import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_SALON_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const SalonReport = lazy(() =>
  import('../../../screens/SalonReport')
    .then(module => ({default: module.SalonReport})));

const SalonReportNavigation = [
  {
    path: ROUTE_SALON_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SalonReport />
      </Suspense>
    ),
  },
];

export default SalonReportNavigation;
